export default {"src":"/_next/static/media/favorite.678d9d7a.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};